var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mb-5" }, [
    _c("h3", { staticClass: "mb-5 text-lg" }, [_vm._v("Měna")]),
    _vm._v(" "),
    _c("div", [
      _c(
        "select",
        {
          staticClass: "pr-5 border-b border-black focus:outline-none",
          attrs: { id: "currency", name: "currency" },
          domProps: { value: _vm.selectedCurrency },
          on: { change: _vm.currencyChanged }
        },
        [
          _c("option", { attrs: { value: "czk" } }, [_vm._v("Kč")]),
          _vm._v(" "),
          _c("option", { attrs: { value: "eur" } }, [_vm._v("Euro")])
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /Users/matej/Works/Code/mago/wp-content/themes/sage/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/Users/matej/Works/Code/mago/wp-content/themes/sage/node_modules/vue-loader/lib?{}!./scripts/vue/checkout/Currency.vue?vue&type=template&id=71046414&
// module id = 161
// module chunks = 0